import { httpClient } from "@coworker/http-client";
import { GroupedSalesLocationsDTO } from "@coworker/apprestructured/src/task-management/types/SalesLocation";

export async function getLocations(
  itemNo: string,
  itemType: string,
  taskTypeId?: string
): Promise<GroupedSalesLocationsDTO> {
  return httpClient.tasks.get<GroupedSalesLocationsDTO>("/locations", {
    params: { itemNo, itemType, ...(taskTypeId && { taskTypeId }) },
  });
}
